import React, { useState } from "react"
import errorPageIcon from '../images/errorPageIcon.svg'
import { Button } from '@mui/material'
import Dashboard from "../pages/Dashboard"
import history from "../history"
import styles from './RouteErrorPage.module.scss'

export default function RouteErrorPage() {
  const [showErrorPage, setshowErrorPage] = useState(true)
  const onClick = () => {setshowErrorPage(false);history.push('/dashboard')}

  return (
    showErrorPage?<div className={styles['container']}>
     <div>
        <div className={styles['error-number']}>404 error</div>
        <div className={styles['error-header']}>Something went wrong</div>
        <div className={styles['error-msg']}>Sorry, the page you are looking for doesn't exist or has been moved. Try searching our site:</div>
        <Button size="large" variant="contained" color="primary" onClick={onClick}>
            Back to main page
        </Button>
     </div>
     <img src={errorPageIcon} alt='error page icon'/>
    </div>:
    <Dashboard />
  )
}
